import { Button, Tooltip } from '@mui/material';
import { SnackbarKey } from 'notistack';
import { ApiResourceState } from '../../types';

type ReportFormBtnControlProps = {
  isSavedDisabled: boolean;
  isGenerateDisabled: boolean;
  onSaveHandler: () => Promise<SnackbarKey | undefined>;
  reportState: {
    status: ApiResourceState;
    error: Error | null;
    data: any;
  };
  onUndo: (sites: any) => void;
  onSubmit: () => void;
  showTooltip?: boolean;
  tooltipMessage?: string;
  // Why Save is disabled, shown on hover; omit for no tooltip.
  saveTooltipMessage?: string;
};
export const ReportFormBtnControl = ({
  isSavedDisabled,
  isGenerateDisabled,
  onSaveHandler,
  reportState,
  onUndo,
  onSubmit,
  showTooltip,
  tooltipMessage = 'At least one column must be added',
  saveTooltipMessage,
}: ReportFormBtnControlProps) => (
  <>
    {/* <Button
        variant="outlined"
        disabled={isSavedDisabled}
        onClick={() => onUndo(watch())}
        sx={{ whiteSpace: 'normal', minHeight: 40 }}
      >
        Undo Changes
      </Button> */}
    <Tooltip title={saveTooltipMessage ?? ''}>
      <span>
        <Button
          disabled={isSavedDisabled}
          size="medium"
          variant="contained"
          onClick={onSaveHandler}
          data-sm="save-template-btn"
          sx={{ whiteSpace: 'normal', minHeight: 40 }}
        >
          {reportState.status === 'LOADING' ? 'Saving template...' : 'Save Template'}
        </Button>
      </span>
    </Tooltip>
    <Tooltip
      title={showTooltip ? tooltipMessage : ''}
      disableHoverListener={!showTooltip}
      disableFocusListener={!showTooltip}
      disableTouchListener={!showTooltip}
    >
      <span>
        <Button
          variant="contained"
          disabled={isGenerateDisabled}
          onClick={onSubmit}
          sx={{ whiteSpace: 'normal', minHeight: 40 }}
        >
          Generate
        </Button>
      </span>
    </Tooltip>
  </>
);
